import { render } from "./CookiesImageCropper.vue?vue&type=template&id=7bd49f9c&scoped=true&ts=true"
import script from "./CookiesImageCropper.vue?vue&type=script&lang=ts"
export * from "./CookiesImageCropper.vue?vue&type=script&lang=ts"

import "./CookiesImageCropper.vue?vue&type=style&index=0&id=7bd49f9c&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bd49f9c"]])

export default __exports__